module.exports = {
  port: 3012,
  database: {
    url: process.env.MICROSERVICE1_DEFAULT_DB_URL || ""
  },
}



// WEBPACK FOOTER //
// /Users/james/code/nextlevel/config/backend/default/microservice1.js